// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__QoRQ0","title":"error_title__GnU9N","img":"error_img__NmJnc","text":"error_text__3oy5N"};